export const isLocalHost = () => window.location.hostname === "localhost";
const cookieDomain = () => (isLocalHost() ? "" : "domain=.border.ly;");

export const setCookie = (name, value, extra = "") => {
  document.cookie = `${name}=${value}; ${cookieDomain()} path=/; samesite=None; secure; ${extra}`;
};

// Clear cookie for both host and parent domain (robust against how it was set)
export const clearCookieEverywhere = (name) => {
  const exp = "expires=Thu, 01 Jan 1970 00:00:00 GMT;";
  // parent domain
  document.cookie = `${name}=; ${cookieDomain()} path=/; ${exp} samesite=None; secure`;
  // host-only (in case it was set without domain)
  document.cookie = `${name}=; path=/; ${exp} samesite=None; secure`;
};

export const setSessionToken = (token) => {
  localStorage.setItem("session_token", token);
  setCookie("session_token", token);
};

export const clearSessionToken = () => {
  localStorage.removeItem("session_token");
  clearCookieEverywhere("session_token");
};

export const mirrorOrgId = (orgId) => {
  if (!orgId) return;
  localStorage.setItem("org_id", orgId);
  setCookie("org_id", orgId);
};

export const clearOrgContext = () => {
  localStorage.removeItem("org_id");
  clearCookieEverywhere("org_id");
};

// The UI flags for the login screen
export const clearLoginUiState = () => {
  localStorage.removeItem("login_email");
  localStorage.removeItem("login_email_sent");
  localStorage.removeItem("login_sent_at");
};

export const resolveInsightsOrigin = () => {
  const h = window.location.hostname;
  const isLocal =
    h === "localhost" ||
    h === "127.0.0.1" ||
    h === "[::1]" ||
    h.endsWith(".localhost");

  return isLocal ? "http://localhost:5173" : "https://ci.border.ly";
};
